module.exports = __webpack_public_path__ + "static/img/murf.2baf4eea.png";